import * as i0 from "@angular/core";
var DateFormatService = /** @class */ (function () {
    function DateFormatService() {
        this.format = "DD/MM/YYYY";
    }
    DateFormatService.prototype.setFormat = function (format) {
        this.format = format;
    };
    DateFormatService.prototype.getFormat = function () {
        return this.format;
    };
    DateFormatService.prototype.getLocale = function () {
        return "en-US";
    };
    DateFormatService.ngInjectableDef = i0.defineInjectable({ factory: function DateFormatService_Factory() { return new DateFormatService(); }, token: DateFormatService, providedIn: "root" });
    return DateFormatService;
}());
export { DateFormatService };
